/*
    For example to display a success alert message with 
    the text 'Registration Successful' you can call
    dispatch(alertActions.success('Registration successful'));
*/

import { alertConstants } from '../actionTypes';
import $ from 'jquery';

export const alertActions = {
    success,
    error,
    secondary,
    clear
};

function success(message) {
    return { type: alertConstants.SUCCESS, message };
}

function error(message) {
    return { type: alertConstants.ERROR, message };
}

function secondary(message){
    return { type: alertConstants.SECONDARY, message };
}

function clear() {
    $('.alert').hide();
    $('.incidents').hide();
    return { type: alertConstants.CLEAR };
}